import { EyeOutlined, MoreOutlined } from "@ant-design/icons";
import { Dropdown, Menu } from "antd";
import { fallbackString, formatDate } from "@/shared/utils";
import "./get-columns.scss";

/* eslint-disable jsx-a11y/anchor-is-valid */
export function getColumns({
  handleView,
}: {
  handleView: (record: any) => void;
}) {
  return [
    {
      title: "№",
      dataIndex: "number",
      key: "number",
      width: 60,
      align: "center",
      sorter: (a: any, b: any) => a.number - b.number,
    },
    {
      title: "Дата добавления записи",
      dataIndex: "addDate",
      key: "addDate",
      width: 100,
      render: (date?: string) => fallbackString(formatDate(date)),
    },
    {
      title: "Дата контрольного (надзорного) мероприятия",
      dataIndex: "controlActionDate",
      key: "controlActionDate",
      width: 100,
      render: (date?: string) => fallbackString(formatDate(date)),
    },
    {
      title: "Данные о проведенных органом ГСН контрольных (надзорных) мероприятиях",
      dataIndex: "GsnActionDate",
      key: "GsnActionDate",
      width: 150,
      render: (text: string) => (
        <div>
          {fallbackString(text)}
        </div>),
    },
    {
      title: "Срок устранения выявленных нарушений",
      dataIndex: "ExpirationDate",
      key: "ExpirationDate",
      width: 100,
      render: (date?: string) => fallbackString(formatDate(date)),
    },
    {
      title: "Должность, фамилия, инициалы, подпись должностного лица",
      dataIndex: "assignedPerson",
      key: "assignedPerson",
      width: 150,
    },
    {
      title: "Фактическая дата устранения  нарушений",
      dataIndex: "infactExpirationDate",
      key: "infactExpirationDate",
      render: (date?: string) => fallbackString(formatDate(date)),
      width: 100,
    },
    {
      title: "Должность, фамилия, инициалы, подпись должностного лица",
      dataIndex: "signAssigneeData",
      key: "signAssigneeData",
      width: 150,
      render: (text:string, record: any) => {
        return (
         <div className="journal-section-six-cell-actions">
          {text}
        <div className="journal-section-six-cell-actions__menu">
        <Dropdown overlay={<Menu items={
          [
            { icon:<EyeOutlined />,
          key:'delete', 
          label:'Просмотр',
          onClick: () => handleView(record),
          },
        ]
          } />} trigger={["click"]}>
          <MoreOutlined className="journal-section-six-cell-actions__trigger" />
        </Dropdown>
        </div>
        </div>
        );
      },
    },
  ];
}
